import classNames from "classnames";
import { Spinner } from 'reactstrap';
import { useRecoilState, } from 'recoil';
import { loadingAtom } from '../../state';

const Loading = () => {
  const [show] = useRecoilState(loadingAtom);

  return show ? <div className="nk-sidebar-overlay d-flex justify-content-center align-items-center" style={{ zIndex: 9999999 }}>
    <Spinner
      className={classNames({
        "position-relative": true,
      })}
      size="lg"
    />
  </div> : ''
}
export default Loading;